import React from 'react';

import { componentFamilyAPI } from 'api/requests';

import Text from 'Components/Text';
import FilePicker from 'Components/FilePicker';

export default ({ family, user }) => {
  return (
    <section className='scene_section'>
      <header>Family</header>
      <Text
        mainWrapperClassName='text__wrapper_primary  _width_pc_100'
        textClassName='text__text_primary'
        label='Family name'
        clickHandler={() => {
          user.goToFamilyDetails(family.id);
        }}
        value={family.name}
      />
      <FilePicker
        isEditable={false}
        sectionHeaderClassName='scene_section-header _margin_top_20'
        notEditableStateSectionHeader='Uploaded Family documents'
        infoMessage='Test reports in this section are shared across the Component Family. Please edit Component Family to add / remove documents.'
        files={family.testReports}
        listSectionId='family_test_reports'
        httpParams={{
          currentId: family.id,
          fileIdFieldName: 'id',
          currentMethod: componentFamilyAPI.downloadReport,
        }}
      />
    </section>
  );
};



// WEBPACK FOOTER //
// ./src/app/Scenes/ComponentManufacturer/Application/Details/FamilyInfo.jsx